export enum DistributionTemplatesEnum {
    DISTRIBUTION_TEMPLATE_BLANK = 'DISTRIBUTION_TEMPLATE_BLANK',
    DISTRIBUTION_TEMPLATE_PRESS_RELEASE = 'DISTRIBUTION_TEMPLATE_PRESS_RELEASE',
    DISTRIBUTION_TEMPLATE_MINIMALIST = 'DISTRIBUTION_TEMPLATE_MINIMALIST',
    DISTRIBUTION_TEMPLATE_MARKETING = 'DISTRIBUTION_TEMPLATE_MARKETING',
}
